<template>
    <section id="price">
        <div class="container is-fluid">
            <div class="columns is-hidden-mobile">
                <div class="column">
                    <div class="columns">
                        <div class="column is-3">

                        </div>
                        <div class="column is-2">
                            <div class="columns">
                                <div class="column has-text-centered">
                                    <img src="../assets/images/price/prijsHome.svg">
                                </div>
                            </div>
                        </div>
                        <div class="column is-4 m-l-10 m-2-10">
                            <div class="columns">
                                <div class="column has-text-centered">                                    
                                    <img :src="($t('Stable'))" style="fill:white">
                                </div>
                            </div>
                        </div>
                        <div class="column is-3">
                            <div class="columns">
                                <div class="column has-text-centered">
                                    <img src="../assets/images/price/prijsPro.svg">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column has-text-centered is-2 is-offset-3">
                            <div class="columns bg__main">
                                <div class="column">
                                    <h3 class="title">
                                        {{$t('Free')}}
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="column is-4 m-r-10">
                            <div class="columns">
                                <div class="column has-text-centered">
                                    <div class="price-horses">
                                        <div class="columns has-text-centered">
                                            <div class="column is-4 border-right">
                                                <div class="columns ">
                                                    <div class="column">
                                                        <h3 class="title is-popular">
                                                            {{$t('Popular')}}
                                                        </h3>
                                                        <h3 class="title m-t-0">
                                                            €1,99
                                                        </h3>
                                                        <p class="small">{{$t('PerMonth')}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="column is-4 border-right">
                                                <div class="columns">
                                                    <div class="column">
                                                        
                                                        <h3 class="title ">
                                                            €2,99
                                                        </h3>
                                                        <p class="small">{{$t('PerMonth')}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="column is-4">
                                                <div class="columns">
                                                    <div class="column">
                                                    
                                                        <h3 class="title">
                                                            €4,99
                                                        </h3>
                                                        <p class="small">{{$t('PerMonth')}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="column is-3">
                            <div class="columns">
                                <div class="column has-text-centered">
                                    <div class="price-horses">
                                        <div class="columns has-text-centered">
                                            <div class="column is-6 border-right">
                                                <div class="columns ">
                                                    <div class="column">
                                                        <h3 class="title">
                                                            €9,99
                                                        </h3>
                                                        <p class="small">{{$t('PerMonth')}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <div class="columns">
                                                    <div class="column">
                                                        <h3 class="title">
                                                            €99,99
                                                        </h3>
                                                        <p class="small">{{$t('PerYear')}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pricing__table columns">
                        <div class="box__one column is-3">
                            <div class="columns">
                            <!-- Omschrijvingen -->
                            <div class="column">
                                <div class="columns height">
                                    <div class="column">
                                        <p>{{$t('PriceBullet1')}}</p>
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <p>{{$t('PriceBullet2')}}</p>
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <p>{{$t('PriceBullet3')}}</p>
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <p>{{$t('PriceBullet4')}}</p>
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <p>{{$t('PriceBullet5')}}</p>
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <p>{{$t('PriceBullet6')}}</p>
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <p>{{$t('PriceBullet7')}}</p>
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <p>{{$t('PriceBullet8')}}</p>
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <p>{{$t('PriceBullet9')}}</p>
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <p>{{$t('PriceBullet10')}}</p>
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <p>{{$t('PriceBullet11')}}</p>
                                    </div>
                                </div>
                            </div>
                            </div>

                        </div>
                        <div class="box__two column is-2">
                            <div class="columns has-text-centered">
                                <div class="column">
                                    <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height has-background">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column has-background">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height has-background">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <strong>1</strong>
                                    </div>
                                </div>
                                <div class="columns height has-background">
                                    <div class="column">
                                        <img src="../assets/images/price/notIncluded.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/price/notIncluded.svg">
                                    </div>
                                </div>
                                <div class="columns height has-background">
                                    <div class="column">
                                        <img src="../assets/images/price/notIncluded.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/price/notIncluded.svg">
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="box__three column is-4">
                            <div class="columns has-text-centered">
                                <div class="column is-4">
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column has-background">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <strong>3</strong>
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-4">
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column has-background">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <strong>5</strong>
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                </div>
                            <div class="column is-4">
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height has-background">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column has-background">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height has-background">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <strong>10</strong>
                                    </div>
                                </div>
                                <div class="columns height has-background">
                                    <div class="column">
                                        <img src="../assets/images/price/notIncluded.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/price/notIncluded.svg">
                                    </div>
                                </div>
                                <div class="columns height has-background">
                                    <div class="column">
                                        <img src="../assets/images/price/notIncluded.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/price/notIncluded.svg">
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    
                        <div class="box__four column is-3">
                            <div class="columns has-text-centered">
                                <div class="column">
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column has-background">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <strong>10</strong>
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="colums is-hidden-tablet">
                <div class="column">
                    <div class="columns is-mobile bg__main">
                        <div @click="showFree" id="select__home" class="column has-text-centered border-right selected">
                            <img src="../assets/images/price/Home.svg">
                        </div>

                        <div @click="showHorse" id="select__horses" class="column has-text-centered border-right">
                            <img :src="($t('StableMobile'))">
                        </div>

                        <div @click="showPro" id="select__pro" class="column has-text-centered">
                            <img src="../assets/images/price/Pro.svg">
                        </div>
                    </div>
                    <div class="columns pricing">
                        <div class="column">
                            <div id="homeTitle" class="columns is-mobile">
                                <div class="column is-8 is-offset-4 has-text-centered">
                                    <h3 class="title">
                                        {{$t('Free')}}
                                    </h3>
                                </div>
                            </div>
                            <div id="horseTitle" class="columns is-mobile has-text-centered" style="display: none;">
                                <div class="column is-offset-4">
                                    <div class="columns is-mobile">
                                        <div class="column is-4 border-right">
                                            <div class="columns ">
                                                <div class="column">
                                                    <h3 class="title is-popular">
                                                        Populair
                                                    </h3>
                                                    <h3 class="title m-t-0">
                                                        €1,99
                                                    </h3>
                                                    <p class="small">{{$t('PerMonth')}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-4 border-right">
                                            <div class="columns">
                                                <div class="column">
                                                    
                                                    <h3 class="title">
                                                        €2,99
                                                    </h3>
                                                    <p class="small">{{$t('PerMonth')}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-4">
                                            <div class="columns">
                                                <div class="column">
                                                    
                                                    <h3 class="title">
                                                        €4,99
                                                    </h3>
                                                    <p class="small">{{$t('PerMonth')}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="proTitle" class="columns is-mobile has-text-centered"  style="display: none;">
                                 <div class="column is-offset-4">
                                     <div class="columns is-mobile">
                                         <div class="column is-6 border-right">
                                            <div class="columns is-mobile">
                                                <div class="column">
                                                    <h3 class="title">
                                                        €9,99
                                                    </h3>
                                                    <p class="small">{{$t('PerMonth')}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-6">
                                            <div class="columns">
                                                <div class="column">
                                                    <h3 class="title">
                                                        €99,99
                                                    </h3>
                                                    <p class="small">{{$t('PerYear')}}</p>
                                                </div>
                                            </div>
                                        </div>
                                     </div>
                                 </div>
                                
                            </div>
                        </div>
                        
                    </div>
                    <div class="columns is-mobile">
                        <div class="column is-4">
                            <div class="horse__description">
                                <div class="columns">
                                <!-- Omschrijvingen -->
                                    <div class="column">
                                        <div class="columns height">
                                            <div class="column">
                                                <p>{{$t('PriceBullet1')}}</p>
                                            </div>
                                        </div>
                                        <div class="columns height">
                                            <div class="column">
                                                <p>{{$t('PriceBullet2')}}</p>
                                            </div>
                                        </div>
                                        <div class="columns height">
                                            <div class="column">
                                                <p>{{$t('PriceBullet3')}}</p>
                                            </div>
                                        </div>
                                        <div class="columns height">
                                            <div class="column">
                                                <p>{{$t('PriceBullet4')}}</p>
                                            </div>
                                        </div>
                                        <div class="columns height">
                                            <div class="column">
                                                <p>{{$t('PriceBullet5')}}</p>
                                            </div>
                                        </div>
                                        <div class="columns height">
                                            <div class="column">
                                                <p>{{$t('PriceBullet6')}}</p>
                                            </div>
                                        </div>
                                        <div class="columns height">
                                            <div class="column">
                                                <p>{{$t('PriceBullet7')}}</p>
                                            </div>
                                        </div>
                                        <div class="columns height">
                                            <div class="column">
                                                <p>{{$t('PriceBullet8')}}</p>
                                            </div>
                                        </div>
                                        <div class="columns height">
                                            <div class="column">
                                                <p>{{$t('PriceBullet9')}}</p>
                                            </div>
                                        </div>
                                        <div class="columns height">
                                            <div class="column">
                                                <p>{{$t('PriceBullet10')}}</p>
                                            </div>
                                        </div>
                                        <div class="columns height">
                                            <div class="column">
                                                <p>{{$t('PriceBullet11')}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="free" class="column is-8">
                            
                            <div class="columns has-text-centered">
                                <div class="column">
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column has-background">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <strong>1</strong>
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="horse" class="column is-8" style="display: none;">
                            
                            <div class="columns is-mobile has-text-centered">
                                <div class="column is-4">
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column has-background">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <strong>3</strong>
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-4">
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column has-background">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <strong>5</strong>
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/price/notIncluded.svg">
                                        </div>
                                    </div>
                                </div>
                            <div class="column is-4">
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height has-background">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column has-background">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height has-background">
                                    <div class="column">
                                        <img src="../assets/images/about/vink.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <strong>10</strong>
                                    </div>
                                </div>
                                <div class="columns height has-background">
                                    <div class="column">
                                        <img src="../assets/images/price/notIncluded.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/price/notIncluded.svg">
                                    </div>
                                </div>
                                <div class="columns height has-background">
                                    <div class="column">
                                        <img src="../assets/images/price/notIncluded.svg">
                                    </div>
                                </div>
                                <div class="columns height">
                                    <div class="column">
                                        <img src="../assets/images/price/notIncluded.svg">
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div id="pro" class="column is-8" style="display: none;">
                            
                            <div class="columns is-mobile has-text-centered">
                                <div class="column">
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column has-background">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <strong>10</strong>
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height has-background">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                    <div class="columns height">
                                        <div class="column">
                                            <img src="../assets/images/about/vink.svg">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
        </div>
    </section>
</template>

<script>

export default {
    name: 'Price',
    components: {

    },
    data () {
        return {
        }
    },
    methods: {
        showFree () {
            var div = document.getElementById('free');
            div.style.display = 'block';
            var divTitle = document.getElementById('select__home');
            divTitle.className += ' selected'

            var homeTitle = document.getElementById('homeTitle')
            homeTitle.style.display = 'block';

            var horse = document.getElementById('horse');
            horse.style.display = 'none';
            var horseTitle = document.getElementById('select__horses');
            horseTitle.classList.remove('selected')

            var horseDivTitle = document.getElementById('horseTitle')
            horseDivTitle.style.display = 'none';

            var pro = document.getElementById('pro');
            pro.style.display = 'none';
            var proTitle = document.getElementById('select__pro');
            proTitle.classList.remove('selected')

            var proDivTitle = document.getElementById('proTitle')
            proDivTitle.style.display = 'none';
        },
        showHorse () {
            var div = document.getElementById('free');
            div.style.display = 'none';
            var divTitle = document.getElementById('select__home');
            divTitle.classList.remove('selected')

            var homeTitle = document.getElementById('homeTitle')
            homeTitle.style.display = 'none';

            var horse = document.getElementById('horse');
            horse.style.display = 'block';

            var horseDivTitle = document.getElementById('horseTitle')
            horseDivTitle.style.display = 'block';

            var horseTitle = document.getElementById('select__horses');
            horseTitle.className += ' selected'

            var pro = document.getElementById('pro');
            pro.style.display = 'none';
            var proTitle = document.getElementById('select__pro');
            proTitle.classList.remove('selected')

            var proDivTitle = document.getElementById('proTitle')
            proDivTitle.style.display = 'none';
        },
        showPro () {
            var div = document.getElementById('free');
            div.style.display = 'none';
            var divTitle = document.getElementById('select__home');
            divTitle.classList.remove('selected')

            var homeTitle = document.getElementById('homeTitle')
            homeTitle.style.display = 'none';

            var horse = document.getElementById('horse');
            horse.style.display = 'none';
            var horseTitle = document.getElementById('select__horses');
            horseTitle.classList.remove('selected')

           var horseDivTitle = document.getElementById('horseTitle')
            horseDivTitle.style.display = 'none';

            var pro = document.getElementById('pro');
            pro.style.display = 'block';
            var proTitle = document.getElementById('select__pro');
            proTitle.className += ' selected'

            var proDivTitle = document.getElementById('proTitle')
            proDivTitle.style.display = 'block';
        }
    }
}
</script>

